import { render, staticRenderFns } from "./PuncherList.vue?vue&type=template&id=3b181788"
import script from "./PuncherList.vue?vue&type=script&lang=js"
export * from "./PuncherList.vue?vue&type=script&lang=js"
import style0 from "./PuncherList.vue?vue&type=style&index=0&id=3b181788&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports